import styled from 'styled-components'

export const Container = styled.div`
	margin: auto;
	max-width: 992px;
	padding: 0 30px;
	min-height: 100vh;
	height: 100%;
	width: 100%;
	background-color: #fff;

	@media screen and (min-width: 390px) {
		padding: 40px;
	}

	@media screen and (min-width: 576px) {
		padding: 73 70px;
	}

	@media screen and (min-width: 768px) {
		padding: 83 85px;
	}

	@media screen and (min-width: 992px) {
		padding: 93px 100px;
	}
`
